import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Auth2FA from "../features/2fa";

/* 2FA */
export const auth2faRoutes = (
    <Route path={ROUTES.auth2fa.home} element={<Auth2FA />} key="auth2fa" />
);
